import mainImg from "../../../assets/mark-door.png";
import thumb1 from "../../../assets/mark-door.png";
import thumb2 from "../../../assets/mark-door.png";


import mainImg1 from "../../../assets/star-door.webp";
import thumb3 from "../../../assets/star-door.webp";
import thumb4 from "../../../assets/star-door.webp";

import mainImg2 from "../../../assets/diamond-door.png";
import thumb5 from "../../../assets/diamond-door.png";
import thumb6 from "../../../assets/diamond-door.png";


import mainImg3 from "../../../assets/pelmet.png";
import thumb7 from "../../../assets/pelmet.png";
import thumb8 from "../../../assets/pelmet.png";


import  mainImg23 from "../../../assets/door-closer.webp";
import thumb47 from "../../../assets/door-closer-thub-one.webp";
import thumb48 from "../../../assets/door-closer-thumb-two.webp";


export  const pullOutProducts = [
  {
  code: "PO-01",
  name: "Mark Eco Hydraulic Door Closer",
  category: "door closer",

  mainImage: mainImg,
  thumbnails: [thumb1, thumb2],

  // ✅ PRICE
  price: "₹1122",
  oldPrice: "₹1,800",
  sku: "7060",
  stock: "In Stock",

  // ✅ LINKS
   catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Mark Eco Door Closer Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/2nZ7ZdVR3aQ",

  // ✅ SHORT DESCRIPTION (FIXED)
  short:
    "Mark Eco Hydraulic Door Closer is a reliable and cost-effective solution for automatic door closing. It ensures smooth, controlled, and silent door operation, making it ideal for residential and commercial applications. Designed for durability and low maintenance, it offers consistent performance with an eco-friendly approach.",

  // ✅ FEATURES (UPDATED)
  features: [
    "Smooth and silent door closing mechanism",
    "Hydraulic system for controlled closing",
    "Strong and durable metal body",
    "Adjustable closing speed",
    "Suitable for wooden and metal doors",
    "Low maintenance and long-lasting performance"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Aluminium Alloy Body" },
    { label: "Mechanism", value: "Hydraulic" },
    { label: "Usage", value: "Door Closing System" },
    { label: "Installation", value: "Surface Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Door Closer Eco",
      code: "7060",
      size: "Up to 45kg Door",
      finish: "Silver"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Hydraulic Door Closer?",
      answer:
        "It is a device that automatically closes a door in a smooth and controlled manner using hydraulic pressure."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in homes, offices, shops, and commercial buildings."
    },
    {
      question: "Can the closing speed be adjusted?",
      answer:
        "Yes, the closing speed can be adjusted according to requirement."
    },
    {
      question: "Is it suitable for heavy doors?",
      answer:
        "Yes, it supports doors up to specific weight capacity depending on the model."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made with strong materials for long-lasting performance."
    }
  ]
},


{
  code: "PO-02",
  name: "Star Regular Hydraulic Door Closer",
  category: "door closer",

  mainImage: mainImg1,
  thumbnails: [thumb3, thumb4],

  // ✅ PRICE
  price: "₹1298",
  oldPrice: "₹2,000",
  sku: "7061",
  stock: "In Stock",

  // ✅ LINKS
    catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Star Regular Door Closer Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/2nZ7ZdVR3aQ",

  // ✅ SHORT DESCRIPTION (FIXED)
  short:
    "Star Regular Hydraulic Door Closer is a reliable and cost-effective solution for smooth and automatic door closing. Designed for everyday use, it ensures controlled closing speed, durability, and consistent performance for residential and commercial spaces.",

  // ✅ FEATURES (UPDATED)
  features: [
    "Hydraulic mechanism for smooth door closing",
    "Adjustable closing and latching speed",
    "Strong and durable metal body",
    "Suitable for wooden and metal doors",
    "Easy installation and low maintenance",
    "Ideal for residential and commercial use"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Aluminium Alloy Body" },
    { label: "Mechanism", value: "Hydraulic" },
    { label: "Usage", value: "Door Closing System" },
    { label: "Installation", value: "Surface Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Door Closer Regular",
      code: "7061",
      size: "Up to 60kg Door",
      finish: "Silver"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Hydraulic Door Closer?",
      answer:
        "It is a device that automatically closes a door in a controlled and smooth manner using hydraulic pressure."
    },
    {
      question: "Where can it be used?",
      answer:
        "It can be used in homes, offices, shops, and commercial buildings."
    },
    {
      question: "Can I adjust the closing speed?",
      answer:
        "Yes, it allows adjustment of closing and latching speed."
    },
    {
      question: "Is it suitable for heavy doors?",
      answer:
        "Yes, it supports medium to heavy doors depending on the model."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made with strong materials for long-lasting performance."
    }
  ]
},


  {
  code: "PO-03",
  name: "Diamond Regular Pelmet Door Closer (Hold Open)",
  category: "door closer",

  mainImage: mainImg2,
  thumbnails: [thumb5, thumb6],

  // ✅ PRICE
  price: "₹1940",
  oldPrice: "₹2,800",
  sku: "7064",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/catalogues/diamond-hold-open-door-closer.pdf",
  inquiry: "https://wa.me/919650100908?text=Diamond Hold Open Door Closer Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/2nZ7ZdVR3aQ",

  // ✅ SHORT DESCRIPTION (FIXED)
  short:
    "Diamond Regular Pelmet Door Closer (Hold Open) is a premium hydraulic door closer designed for smooth, controlled door movement with a convenient hold-open feature. It allows the door to stay open at a desired angle, making it ideal for high-traffic areas in residential and commercial spaces.",

  // ✅ FEATURES (UPDATED)
  features: [
    "Hold-open function keeps door open at desired angle",
    "Hydraulic mechanism for smooth and silent closing",
    "Strong and durable metal body",
    "Adjustable closing and latching speed",
    "Ideal for high-traffic areas",
    "Suitable for wooden and metal doors"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Aluminium Alloy Body" },
    { label: "Mechanism", value: "Hydraulic Hold Open" },
    { label: "Usage", value: "Door Closing System" },
    { label: "Installation", value: "Surface Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Door Closer Hold Open",
      code: "7064",
      size: "Up to 85kg 900 Door",
      finish: "Silver"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Hold Open Door Closer?",
      answer:
        "It is a door closer that can hold the door open at a fixed angle and close it when released."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in offices, hospitals, showrooms, and high-traffic areas."
    },
    {
      question: "Can the closing speed be adjusted?",
      answer:
        "Yes, it allows adjustment of closing and latching speed."
    },
    {
      question: "Is it suitable for heavy doors?",
      answer:
        "Yes, it supports medium to heavy doors depending on the model."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials for long-lasting performance."
    }
  ]
},
{
  code: "PO-04",
  name: "Premium PVD Finish Door Closer (Black / Gold / Rose Gold / Antique)",
  category: "door closer",

  mainImage: mainImg3,
  thumbnails: [thumb7, thumb8],

  // ✅ PRICE
  price: "₹2706",
  oldPrice: "₹3,200",
  sku: "7486",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/catalogues/pvd-door-closer.pdf",
  inquiry: "https://wa.me/919650100908?text=PVD Finish Door Closer Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/2nZ7ZdVR3aQ",

  // ✅ SHORT DESCRIPTION (FIXED)
  short:
    "Premium PVD Finish Door Closer is a high-end hydraulic door closer available in Black, Gold, Rose Gold, and Antique finishes. It combines smooth door closing performance with stylish aesthetics, making it ideal for modern interiors where design and functionality both matter.",

  // ✅ FEATURES (UPDATED)
  features: [
    "Available in Black, Gold, Rose Gold, and Antique finishes",
    "Advanced PVD coating for premium look and durability",
    "Hydraulic mechanism for smooth and silent closing",
    "Corrosion-resistant and long-lasting finish",
    "Perfect for luxury interiors and designer spaces",
    "Suitable for wooden and metal doors"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Aluminium Alloy + PVD Coating" },
    { label: "Mechanism", value: "Hydraulic" },
    { label: "Usage", value: "Door Closing System" },
    { label: "Installation", value: "Surface Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Door Closer PVD Black",
      code: "7486",
      size: "Up to 100kgs Door",
      finish: "Black"
    },
    {
      item: "Door Closer PVD Gold",
      code: "7487",
      size: "Up to 100kgs Door",
      finish: "Gold"
    },
    {
      item: "Door Closer PVD Rose Gold",
      code: "7488",
      size: "Up to 100kgs Door",
      finish: "Rose Gold"
    },
    {
      item: "Door Closer PVD Antique",
      code: "7696",
      size: "Up to 100kgs Door",
      finish: "Antique"
    }
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a PVD Finish Door Closer?",
      answer:
        "It is a door closer with a special PVD coating that provides a premium metallic finish and long-lasting durability."
    },
    {
      question: "Which finishes are available?",
      answer:
        "It is available in Black, Gold, Rose Gold, and Antique finishes."
    },
    {
      question: "Is the finish durable?",
      answer:
        "Yes, PVD coating is highly durable and resistant to corrosion and scratches."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in premium homes, offices, hotels, and designer spaces."
    },
    {
      question: "Does it work like a normal door closer?",
      answer:
        "Yes, it provides smooth and controlled hydraulic door closing."
    }
  ]
},

  {
  code: "7568",
  name: "Hydraulic Door Closer Standard",
  category: "door closer",

  mainImage: mainImg23,
  thumbnails: [thumb47, thumb48],

  // ✅ PRICE
  price: "₹1,750",
  oldPrice: "₹2,200",
  sku: "7568",
  stock: "In Stock",

  // ✅ LINKS
     catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Door Closer Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/2nZ7ZdVR3aQ",

  // ✅ SHORT DESCRIPTION (CLEAN)
  short:
    "Hydraulic Door Closer Standard is a reliable door control solution designed for smooth, silent, and automatic door closing. Built with a durable hydraulic mechanism, it ensures controlled movement, prevents slamming, and enhances door safety and longevity.",

  // ✅ FEATURES (OPTIMIZED)
  features: [
    "Smooth and silent door closing",
    "Hydraulic mechanism for controlled movement",
    "Prevents door slamming and damage",
    "Adjustable closing and latching speed",
    "Strong and durable metal construction",
    "Suitable for residential and commercial use"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Material", value: "Aluminium Alloy Body" },
    { label: "Mechanism", value: "Hydraulic" },
    { label: "Usage", value: "Door Closing System" },
    { label: "Installation", value: "Surface Mount" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Door Closer Standard",
      code: "",
      size: "Up to 60kg Door",
      finish: "Silver"
    },
    
  ],

  // ✅ FAQ (IMPROVED)
  faq: [
    {
      question: "What is a Hydraulic Door Closer?",
      answer:
        "It is a mechanical device that automatically closes doors smoothly using hydraulic pressure."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in homes, offices, shops, and commercial buildings."
    },
    {
      question: "Can I adjust the closing speed?",
      answer:
        "Yes, it allows adjustment of both closing and latching speed."
    },
    {
      question: "Does it prevent door slamming?",
      answer:
        "Yes, it ensures controlled closing and prevents damage caused by slamming."
    },
    {
      question: "Is it suitable for heavy doors?",
      answer:
        "Yes, different models support different door weights."
    }
  ]
}
];
